// This polyfill is essential to ensure that urql (>= v4) (and wonka) work on
// native platforms.
//
// See: https://github.com/aws-amplify/amplify-js/issues/10764#issuecomment-1363140556
//
// The issue listed above recommends simply updating wonka, but this did not
// resolve the issue in our case, thus we had to add this polyfill.
//
// This can be removed if Hermes supports 'AsyncGenerator' out of the box.
import 'core-js/full/symbol/async-iterator';

import 'expo-asset';
import 'expo-dev-client';
import { LogBox } from 'react-native';

import { injectAppsFlyerSmartScript } from '@order/integrations/appsflyer';
import {
  fixAndroidKeyboardLayoutShifts,
  fixIosFullHeightIssue,
  hideStripeSvgLoadingElement,
} from '@order/utils';

import { addSnapPixelScript, initDatadog, loadOneTrust } from './src/integrations';
import { intlPolyfill } from './src/polyfills';

// ─────────────────────────────────────────────────────────────────────────────

// FIXME we need to fix the underlying issue for Android; this is here so that Android e2e tests can pass.
// The warning it is hiding is covering UI elements the test runner is trying to interact with.
LogBox.ignoreAllLogs();

loadOneTrust();
injectAppsFlyerSmartScript();
addSnapPixelScript();
intlPolyfill();
void initDatadog();
fixAndroidKeyboardLayoutShifts();
hideStripeSvgLoadingElement();
fixIosFullHeightIssue();

// ─────────────────────────────────────────────────────────────────────

/**
 * ⚠️ DO NOT MOVE — MUST REMAIN THE LAST STATEMENT IN THIS FILE ⚠️
 *
 * >Import or add your custom configuration to the file. Then, import expo-router/entry to register
 *  the app entry. Remember to always import it last to ensure all configurations are properly
 *  set up before the app renders.
 *
 * @see https://docs.expo.dev/router/installation/#custom-entry-point-to-initialize-and-load
 *
 * 🚨 The trailing `// prettier-ignore` pins this import so the import-sorter
 *    cannot hoist it to the top of the file and break the initialization
 *    order. Keep both the comment and the placement intact.
 */
import 'expo-router/entry'; // prettier-ignore
